module.exports = __webpack_public_path__ + "img/fb39757.jpg";